<template>
  <!-- 日历订阅组件开始 -->
  <div>
    <van-cell v-if="isSelf" class="text-center cell-btm-none"
              title="订阅我的会议日历" title-class="text-sm"
              @click="showSheet = true" is-link></van-cell>
    <van-sticky v-else :offset-top="30">
      <van-tag class="right-tag pull-right" mark type="warning" size="medium"
               @click="showSheet = true">订阅{{roomTitle}}日历
      </van-tag>
    </van-sticky>

    <van-popup v-model="showSheet" round position="bottom">
      <div class="van-share-sheet__header">
        <h2 class="van-share-sheet__title">订阅{{title || '我的'}}会议日历</h2>
        <span class="van-share-sheet__description text-ellipsis">{{subsUrl}}</span>
      </div>
      <div class="van-share-sheet__options text-center">
        <div id="subsUrl" class="van-share-sheet__option"
             :data-clipboard-text="subsUrl" @click="onCopy">
          <img src="../../../assets/icon-link.png" class="van-share-sheet__icon">
          <span class="van-share-sheet__name">复制链接</span>
        </div>
        <div class="van-share-sheet__option" @click="showSheet=false">
          <van-icon name="cross" class="van-share-sheet__icon btn-round-icon"></van-icon>
          <span class="van-share-sheet__name">取消</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {getStorage, StorageKey} from "../../../tools/storage";
  import ClipboardJS from "clipboard" // 复制组件相关

  export default {
    props: {
      isSelf: Boolean,
      title: String,
    },
    data() {
      return {
        showSheet: false,
        clipboard: null,
      }
    },
    computed: {
      paramId: function () {
        if (this.isSelf) {
          return this.$store.state.userId || getStorage(StorageKey.userId)
        }
        return this.$route.params.rid
      },
      subsUrl: function () {
        return window.serviceUrl + `/calendar/subs/${this.isSelf ? 'user' : 'room'}/${this.paramId}.ics`
      },
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
    },
    mounted() {
      // 复制链接
      this.clipboard = new ClipboardJS('#subsUrl');
    },
    destroyed() {
      this.clipboard && this.clipboard.destroy();
    },
    methods: {
      onCopy() {
        // console.log(this.paramId);
        vtToast("已复制~");
        this.showSheet = false;
      },
    }
  }
</script>

<style lang="less">
  .van-share-sheet__options {
    width: max-content;
    margin: 0 auto;
  }
</style>
